'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Find_Photo = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Find_Photo, _React$Component);

  function Find_Photo(props) {
    (0, _classCallCheck3.default)(this, Find_Photo);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Find_Photo.__proto__ || (0, _getPrototypeOf2.default)(Find_Photo)).call(this, props));

    _this.state = {
      totalPlaces: 3,
      currentView: 1, //comenzamos a 1
      currentExplanation: 1, //Por que parte de la explicación vamos
      numToShow: '',
      currentPhoto: 0, //la photo que estamos buscando
      bgPhoto: 0, //la foto que mostramos
      txtHintToShow: '',
      txtSolutionToShow: '',
      titleToShow: ''
    };
    return _this;
  }

  (0, _createClass3.default)(Find_Photo, [{
    key: 'nextExplanation',
    value: function nextExplanation() {

      if (document.getElementsByClassName('text showed').length > 0) {
        for (var i = document.getElementsByClassName('text showed').length - 1; i >= 0; i--) {
          document.getElementsByClassName('text showed')[i].classList.remove('showed');
        }
      }

      if (this.state.currentExplanation === 3) {
        setTimeout(function () {
          this.setState({
            currentView: this.state.currentView + 1
          });
        }.bind(this), 800);
      } else {
        setTimeout(function () {
          this.setState({
            currentExplanation: this.state.currentExplanation + 1
          });
        }.bind(this), 800);
      }
    }
  }, {
    key: 'nextView',
    value: function nextView() {

      setTimeout(function () {
        this.setState({
          currentView: this.state.currentView + 1
        });
      }.bind(this), 800);
    }
  }, {
    key: 'hidePhoto',
    value: function hidePhoto(ev) {
      this.setState({
        bgPhoto: 0
      });
    }
  }, {
    key: 'showPhoto',
    value: function showPhoto(ev) {
      var elem = void 0,
          photoSelected = void 0,
          image = void 0,
          num = void 0;
      ev.target.classList.contains('icon-loupe') ? elem = ev.target.parentElement : elem = ev.target;

      photoSelected = elem.getAttribute('data-photo');
      image = this.context.baseUrl + this.props.interactionTxt.photos[photoSelected].photoSrc;
      num = photoSelected.substr(-1);

      this.setState({
        bgPhoto: parseInt(num),
        currentPhoto: parseInt(num)
      });

      //si hay elemento clicado, se lo kitamos
      if (document.getElementsByClassName('clicked').length > 0) {
        document.getElementsByClassName('clicked')[0].classList.remove('clicked');
      }

      elem.classList.add('clicked');
    }
  }, {
    key: 'textEffect',
    value: function textEffect(keyText) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var textos = this.props.interactionTxt.photos;
      var newHintText = void 0,
          newSolutionText = void 0,
          newTitle = void 0,
          newNum = '';

      if (!type) {
        newHintText = textos[keyText];
      } else {
        newTitle = textos[type + 'Title'];
        newSolutionText = textos[keyText][type + 'Text'];
        newNum = keyText.substr(-1);
      }

      this.refs.showTextHint.classList.add('toLeft');

      setTimeout(function () {
        var _this2 = this;

        this.setState({
          txtHintToShow: newHintText,
          txtSolutionToShow: newSolutionText,
          titleToShow: newTitle,
          numToShow: newNum
        }, function () {
          _this2.refs.showTextHint.classList.add('fromRight');
          _this2.refs.showTextHint.classList.remove('toLeft');

          setTimeout(function () {
            this.refs.showTextHint.classList.remove('fromRight');
          }.bind(_this2), 300);
        });
      }.bind(this), 300);
    }
  }, {
    key: 'checkClick',
    value: function checkClick(ev) {
      var currentPhoto = 'photo' + this.state.currentPhoto;

      if (currentPhoto == 'photo0') {

        if (ev.target.classList.contains('visible')) {
          this.correctClick(ev.target);
        } else {
          this.textEffect('selectClue');
        }
      } else if (!document.getElementsByClassName('photo')[0].classList.contains('namePhoto0')) {
        if (!ev.target.classList.contains('icon-close')) this.textEffect('closeClue');
      } else {
        //si la foto seleccionada se corresponde con el span.place
        if (ev.target.classList.contains(currentPhoto)) {
          this.correctClick(ev.target);
        } else {
          this.wrongClick();
        }
      }
    }
  }, {
    key: 'correctClick',
    value: function correctClick(elem) {
      if (this.state.currentPhoto == 0) {
        this.textEffect(elem.classList[1], 'correct');
      } else {
        this.textEffect('photo' + this.state.currentPhoto, 'correct');
      }

      elem.classList.add('visible');
      this.setState({
        currentPhoto: 0
      });

      document.getElementsByClassName('clicked')[0].classList.add('solved');
      document.getElementsByClassName('clicked')[0].classList.remove('clicked');

      /*Chekeamos si hemos seleccionado todos los puntos*/
      if (document.getElementsByClassName('place visible').length == this.state.totalPlaces) {
        document.getElementsByClassName('nextView')[0].classList.add('visible');
        //hacer no clicable
      }
    }
  }, {
    key: 'wrongClick',
    value: function wrongClick(elem) {
      this.textEffect('photo' + this.state.currentPhoto, 'wrong');

      document.getElementsByClassName("meneo")[0].classList.add('failCombination');
      setTimeout(function () {
        document.getElementsByClassName("meneo")[0].classList.remove('failCombination');
      }.bind(this), 620);
    }
  }, {
    key: 'showTextExplanation',
    value: function showTextExplanation(ev) {
      ev.target.parentElement.getElementsByClassName('text')[0].classList.add('showed');
    }
  }, {
    key: 'render',
    value: function render() {

      var txt = this.props.interactionTxt;
      var buttonStart = this.props.buttonStart;
      var clues = txt.photos.pista;
      var buttonContinue = this.props.buttonContinue;
      var explanation = txt.explanation['view' + this.state.currentExplanation];
      var photos = txt.photos;
      var current = 'photo' + this.state.currentPhoto;

      var showView = void 0;
      var classHidden = this.state.numToShow > 0 ? '' : 'hidden';

      switch (this.state.currentView) {
        case 1:
          showView = _react2.default.createElement(
            'div',
            { key: 'FindPhoto1', className: "instrucctionsPhoto instruction" + this.state.currentView },
            _react2.default.createElement(
              'div',
              { className: 'table' },
              _react2.default.createElement(
                'div',
                { className: 'cell' },
                _react2.default.createElement(_components.PointsAndSvg, { cName: this.state.currentView, icon: 'icon-hand', clickIcon: this.nextView.bind(this) }),
                _react2.default.createElement(
                  'p',
                  { className: 'first' },
                  txt.instructions1.title
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'div',
                  { onClick: this.nextView.bind(this), className: "nextView " + this.props.caseId },
                  _react2.default.createElement(
                    'span',
                    null,
                    buttonStart
                  ),
                  _react2.default.createElement('i', { className: 'icon-arrowright' })
                )
              )
            ),
            _react2.default.createElement('div', { className: 'opacityCover' })
          );
          break;

        case 2:
          showView = _react2.default.createElement(
            'div',
            { key: "FindPhoto2-" + this.state.currentExplanation, className: "instrucctionsPhoto dayNight instruction" + this.state.currentView + " explanation" + this.state.currentExplanation },
            _react2.default.createElement(
              'div',
              { className: 'day' },
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement('i', { className: 'icon-day' }),
                _react2.default.createElement(
                  'span',
                  null,
                  'D\xEDa'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'place', onMouseEnter: this.showTextExplanation.bind(this) },
                _react2.default.createElement(
                  'span',
                  { className: 'number' },
                  '0',
                  this.state.currentExplanation
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'text' },
                explanation.day
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'night' },
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement('i', { className: 'icon-night' }),
                _react2.default.createElement(
                  'span',
                  null,
                  'Noche'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'place', onMouseEnter: this.showTextExplanation.bind(this) },
                _react2.default.createElement(
                  'span',
                  { className: 'number' },
                  '0',
                  this.state.currentExplanation
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'text' },
                explanation.night
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'explanationPoints' },
              _react2.default.createElement('span', { className: 'position' }),
              _react2.default.createElement('span', { className: 'point' }),
              _react2.default.createElement('span', { className: 'position' }),
              _react2.default.createElement('span', { className: 'point' }),
              _react2.default.createElement('span', { className: 'position' })
            ),
            _react2.default.createElement(
              'div',
              { onClick: this.nextExplanation.bind(this), className: "nextView nextExplanation " + this.props.caseId },
              _react2.default.createElement(
                'span',
                null,
                buttonContinue
              ),
              _react2.default.createElement('i', { className: 'icon-arrowright' })
            )
          );

          break;

        case 3:
          showView = _react2.default.createElement(
            'div',
            { key: 'FindPhoto3', className: "instrucctionsPhoto instruction" + this.state.currentView },
            _react2.default.createElement(
              'div',
              { className: 'table' },
              _react2.default.createElement(
                'div',
                { className: 'cell' },
                _react2.default.createElement(_components.PointsAndSvg, { cName: this.state.currentView, icon: 'icon-warning', clickIcon: this.nextView.bind(this) }),
                _react2.default.createElement(
                  'p',
                  { className: 'first' },
                  txt.instructions2.title
                ),
                _react2.default.createElement(
                  'p',
                  { className: 'second' },
                  txt.instructions2.subtitle
                ),
                _react2.default.createElement(
                  'div',
                  { onClick: this.nextView.bind(this), className: "nextView " + this.props.caseId },
                  _react2.default.createElement(
                    'span',
                    null,
                    buttonContinue
                  ),
                  _react2.default.createElement('i', { className: 'icon-arrowright' })
                )
              )
            ),
            _react2.default.createElement('div', { className: 'opacityCover' })
          );
          break;

        case 4:
          showView = _react2.default.createElement(
            'div',
            { key: 'FindPhoto4', className: "instrucctionsPhoto instruction" + this.state.currentView },
            _react2.default.createElement(
              'div',
              { className: 'container' },
              _react2.default.createElement(
                'div',
                { className: 'title' },
                ' ',
                photos.title,
                ' '
              ),
              _react2.default.createElement(
                'div',
                { className: "meneo photo namePhoto" + this.state.bgPhoto, onClick: this.checkClick.bind(this) },
                _react2.default.createElement('i', { className: 'icon-close', onClick: this.hidePhoto.bind(this) }),
                _react2.default.createElement('img', { src: this.context.baseUrl + photos.src }),
                _react2.default.createElement(
                  'span',
                  { className: 'place photo1' },
                  _react2.default.createElement(
                    'div',
                    { className: 'num' },
                    '1'
                  )
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'place photo3' },
                  _react2.default.createElement(
                    'div',
                    { className: 'num' },
                    '3'
                  )
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'place photo2' },
                  _react2.default.createElement(
                    'div',
                    { className: 'num' },
                    '2'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'thumbs' },
                _react2.default.createElement(
                  'div',
                  { className: 'title' },
                  ' ',
                  clues,
                  ' '
                ),
                (0, _keys2.default)(photos).map(function (key, index) {
                  if (index < 3) return _react2.default.createElement(
                    'span',
                    { key: 'thumb' + key },
                    _react2.default.createElement(
                      'span',
                      { className: 'num' },
                      '0',
                      index + 1
                    ),
                    _react2.default.createElement(
                      'div',
                      { 'data-photo': 'photo' + parseInt(index + 1), onClick: this.showPhoto.bind(this), style: { 'backgroundImage': 'url(' + this.context.baseUrl + photos['photo' + parseInt(index + 1)].thumbSrc + ')' } },
                      _react2.default.createElement('i', { className: 'icon-loupe' })
                    )
                  );
                }, this)
              ),
              _react2.default.createElement(
                'div',
                { className: 'txtLeft', ref: 'showTextSolution' },
                _react2.default.createElement(
                  'span',
                  { className: "solution num " + classHidden },
                  '0',
                  this.state.numToShow
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'txtBottom', ref: 'showTextHint' },
                  _react2.default.createElement(
                    'span',
                    { className: 'hint title' },
                    this.state.titleToShow
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'hint text' },
                    this.state.txtHintToShow
                  )
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'solution text' },
                  this.state.txtSolutionToShow
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { onClick: this.props.showConclusion.bind(this), className: "nextView " + this.props.caseId },
              _react2.default.createElement(
                'span',
                null,
                buttonContinue
              ),
              _react2.default.createElement('i', { className: 'icon-arrowright' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'copyright' },
              ' ',
              this.props.copyright,
              ' '
            )
          );
          break;
      }

      return _react2.default.createElement(
        'div',
        { className: 'findInteraction view' + this.state.currentView },
        _react2.default.createElement(
          _reactAddonsCssTransitionGroup2.default,
          { transitionName: 'view', transitionEnter: true, transitionEnterTimeout: 1000, transitionLeave: true, transitionLeaveTimeout: 1000 },
          showView
        )
      );
    }
  }]);
  return Find_Photo;
}(_react2.default.Component), _class.contextTypes = {
  baseUrl: _react.PropTypes.string.isRequired,
  project: _react.PropTypes.string.isRequired
}, _temp);
exports.default = Find_Photo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Find_Photo/Find_Photo.js
// module id = 792
// module chunks = 0